// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blastoise: PokeData = {
  "id": 9,
  "name": "blastoise",
  "height": 16,
  "weight": 855,
  "base_experience": 239,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "tail-whip",
    "bite",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "withdraw",
    "skull-bash",
    "bubble",
    "protect",
    "rapid-spin",
    "rain-dance",
    "fake-out",
    "iron-defense",
    "water-pulse",
    "aqua-tail",
    "flash-cannon",
    "aqua-jet",
    "shell-smash",
    "wave-crash"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "protect",
    "rain-dance",
    "iron-defense",
    "aqua-tail",
    "aqua-jet",
    "whirlpool",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 3,
    "item": null,
    "species": [
      {
        "name": "squirtle",
        "order": 7,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wartortle",
        "order": 8,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 7,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blastoise",
        "order": 9,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 8,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 123,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
